import { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./journalTypeDetail.css";
import BeforeFooter from "../components/layout/BeforeFooter";
import journalTypesData from "../data/journaling/journalTypesData";
import logo from "../assets/elby.png";

function JournalTypeDetail() {
  const { type } = useParams();
  const data = journalTypesData[type];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  // Unknown slug in the URL -> back to the overview instead of a blank page
  if (!data) {
    return <Navigate to="/journaling" replace />;
  }

  return (
    <>
      {/* HERO — tinted with this type's accent color */}
      <section className="jtd-hero" style={{ background: data.accentSoft }}>
        <Link to="/journaling" className="jtd-back">
          ← Ways to Journal
        </Link>

        <span className="jtd-icon">{data.icon}</span>
        <h1>{data.title}</h1>
        <p className="jtd-subtitle">{data.subtitle}</p>

        <div className="jtd-quote">
          <p>"{data.quote}"</p>
        </div>

        <img src={logo} alt="Elby" className="jtd-signature" />
      </section>

      {/* LAYOUT — sticky ToC sidebar on the left, content on the right */}
      <div className="jtd-layout" style={{ "--toc-accent": data.accent, "--toc-soft": data.accentSoft }}>
        <nav
          className="jtd-toc"
          aria-label="In this article"
        >
          <h3>In this article</h3>
          <div className="jtd-toc-list">
            {data.sections.map((section, i) => (
              <a href={`#section-${i}`} key={i}>
                <span className="jtd-toc-number">{String(i + 1).padStart(2, "0")}</span>
                <span>{section.heading}</span>
              </a>
            ))}
            <a href="#prompts">
              <span className="jtd-toc-number">
                {String(data.sections.length + 1).padStart(2, "0")}
              </span>
              <span>Prompts to try</span>
            </a>
          </div>
        </nav>

        <div className="jtd-content">
          {/* CONTENT SECTIONS — plain heading + paragraph, no cards */}
          {data.sections.map((group, i) => (
            <section className="jtd-section" id={`section-${i}`} data-aos="fade-up" key={i}>
              <h2>{group.heading}</h2>
              {group.items.map((item, j) => (
                <div className="jtd-subsection" key={j}>
                  {item.subheading && <h3>{item.subheading}</h3>}
                  {item.image && (
                    <img src={item.image} alt={item.subheading || group.heading} className="jtd-section-image" />
                  )}
                  <p>{item.text}</p>
                  {item.links && (
                    <ul className="jtd-links">
                      {item.links.map((link, k) => (
                        <li key={k}>
                          {link.internal ? (
                            <Link to={link.url}>{link.label}</Link>
                          ) : (
                            <a href={link.url} target="_blank" rel="noopener noreferrer">
                              {link.label}
                            </a>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </section>
          ))}

          {/* PROMPTS — divided list, no cards */}
          <section className="jtd-section" id="prompts" data-aos="fade-up">
            <h2>Prompts to try</h2>
            <ul className="jtd-prompt-list">
              {data.prompts.map((prompt, i) => (
                <li key={i}>{prompt}</li>
              ))}
            </ul>
          </section>
        </div>
      </div>

      <BeforeFooter />
    </>
  );
}

export default JournalTypeDetail;